{
  "title": "Send a message",
  "messageText": "Message text",
  "messageTextPlaceholder": "Type the message text...",
  "characterCount": "{{count}}/{{max}} characters",
  "selectAll": "Select all",
  "searchLabel": "Search for a debtor",
  "searchPlaceholder": "Search by name or phone...",
  "recipientsTitle": "Debtors",
  "selectedCount": "{{count}} of {{total}} selected",
  "invalidPhoneReason": "Invalid number",
  "send": "Send",
  "confirmSend": "Send the message to {{count}} debtors",
  "confirmSendDescription": "The message will be sent only to the debtors you selected.",
  "status": {
    "queued": "Queued",
    "sent": "Sent",
    "delivered": "Delivered",
    "read": "Read",
    "failed": "Failed",
    "invalid_phone": "Invalid number"
  },
  "toasts": {
    "result": "Sent to {{queued}} debtors, skipped {{skipped}} for an invalid number"
  },
  "validation": {
    "messageRequired": "This field is required",
    "noRecipients": "Choose at least one debtor"
  },
  "empty": {
    "noResults": "No results"
  }
}
